import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { BadgeCheck, Layers, Zap } from "lucide-react";

const ICONS = [BadgeCheck, Layers, Zap];

export default function TrustStrip() {
  const { t } = useLang();
  const ref = useReveal();
  const gallery = t.trust.gallery;

  return (
    <section className="bg-[#0d2140]">
      {/* Gallery marquee */}
      <div className="marquee-track overflow-hidden -mt-px">
        <div className="flex w-max animate-marquee">
          {[...gallery, ...gallery].map((g, i) => (
            <div key={i} className="relative w-64 h-40 md:w-80 md:h-52 shrink-0">
              <img src={g.img} alt={g.label} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#081527]/90 to-transparent" />
              <span className="absolute bottom-3 left-3 text-white text-xs font-700 uppercase tracking-wider font-display">
                {g.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Trust items */}
      <div ref={ref} className="reveal max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-8">
        {t.trust.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <div key={i} className="flex gap-4">
              <span className="shrink-0 flex items-center justify-center w-12 h-12 rounded-xl bg-[#f5871f]/15 border border-[#f5871f]/30">
                <Icon className="w-6 h-6 text-[#f5871f]" />
              </span>
              <div>
                <h3 className="text-white font-700 text-lg uppercase tracking-wide font-display">{item.title}</h3>
                <p className="text-white/60 text-sm mt-1 leading-relaxed">{item.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
